// The Geographic Center of the United States/Coordinates
export const geographicCenterOfUnitedStates = {
  lat: 39.829153,
  lng: -98.579523
};
